module.exports = __webpack_public_path__ + "img/company_inactive.cc304615.svg";